import { useAuth0 } from "@auth0/auth0-react";
import DefaultEmptyMsg from "components/DefaultEmptyMsg/DefaultEmptyMsg";
import SearchDownShift from "components/downmshift/DownShift";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import NotAuthorized from "../../../../components/NotAuthorized";
import SearchComp from "../../../../components/Searchcomponent";
import SettingHeader from "../../SettingHeader/settingHEader";
import Tree from "../../Tree/Tree";
import ComponentHeading from "../../componentHeading/ComponentHeading";

const LedgerAccounts = ({ heading }) => {
  const [ledgerSubledger, setLedgerSubledger] = useState("");
  const [type, setType] = useState("");
  const [disableAddNew, setDaisableAddNew] = useState();
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState("");
  const [showNameChangeConfirm, setShowNameChangeConfirm] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [ledgerSubLedgerList, setLedgerSubLedgerList] = useState([]);
  const [ledgerSubLedgerData, setLedgerSubLedgerData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [ledgerSubLedgertype, setLedgerSubLedgertype] = useState("");
  const [ledgerSubLedgerId, setLedgerSubLedgerId] = useState("");
  const [ledgerNameList, setLedgeNameList] = useState("");
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const [selected, setSelected] = useState("");
  const [selectedSubLedger, setSelectedSubLedger] = useState({});

  const localStorageData = localStorage.getItem("organization")
  ? JSON.parse(localStorage.getItem("organization"))
  : null;
  const activeQuickBooksProgram = localStorageData?.quickBooks_information?.program;

  const history = useHistory();
  const { push } = useHistory();
  const formik = useFormik({
    enableReinitialize: true,

    initialValues:
      addNew === true
        ? {
          parent_ledger: "",
          ledgerId: "",
          ledgerforId: "",

          ledger_name: "",
          default_amount: "",
          amount_deductible: 100,
          deductibleType: "%",
          // gateway_fee_override: "",
          // feeType: "%",
          donation: false,
          require_notes: "",
          archived: "",
          defaultCOA:"",
          ledger_checkbox: "",
          account_receivable: "",
          quickBooks_id: "",
          quickBooks_name: "",
          quickBooksClass_name: "",
          quickBooksClass_id: "",
          showOnCheckout: false,
          checkoutTitle: "",
          checkoutLabel: "",
          checkoutAmounts: [],
          checkoutAllowOther: false,
        }
        : {
          ledger_checkbox: ledgerSubLedgerData?.sub_ledger_name ? "" : true,

          parent_ledger: ledgerSubLedgerData?.ledger_name,
          ledgerId: ledgerSubLedgerData?.ledgerId ?? ledgerSubLedgerData?._id,
          ledgerforId: ledgerSubLedgerData?._id,

          ledger_name: ledgerSubledger,
          default_amount: ledgerSubLedgerData?.default_amount ?? 0,
          amount_deductible: ledgerSubLedgerData?.amount_detuctible ?? 0,
          deductibleType: ledgerSubLedgerData?.deductibleType ?? "%",
          // gateway_fee_override: ledgerSubLedgerData?.gateway_fee ?? 0,
          // feeType: ledgerSubLedgerData?.feeType ?? "%",
          donation: ledgerSubLedgerData?.donation,
          require_notes: ledgerSubLedgerData?.notes,
          archived: !ledgerSubLedgerData?.active,
          defaultCOA: ledgerSubLedgerData?.defaultCOA,
          account_receivable: ledgerSubLedgerData?.account_receivable,
          quickBooks_id: ledgerSubLedgerData?.quickBooks_id,
          quickBooks_name: ledgerSubLedgerData?.quickBooks_name,
          quickBooksClass_name: ledgerSubLedgerData?.quickBooksClass_name,
          quickBooksClass_id: ledgerSubLedgerData?.quickBooksClass_id,
          showOnCheckout: ledgerSubLedgerData?.showOnCheckout ?? false,
          checkoutTitle: ledgerSubLedgerData?.checkoutTitle ?? "",
          checkoutLabel: ledgerSubLedgerData?.checkoutLabel ?? "",
          checkoutAmounts: ledgerSubLedgerData?.checkoutAmounts ?? [],
          checkoutAllowOther: ledgerSubLedgerData?.checkoutAllowOther ?? false,
        },
  });

  // Get LedgerSubLedgers List
  const fetchMyAPI = async (ledgerType = "", ledgerId = "", type = "") => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getLedgerSubLedgerList(token).then((res) => {
      setLedgerSubLedgerList(res?.ledgers ?? []);
      setType(ledgerType || res?.ledgers[0]?.ledger_name);
      if(ledgerId){
        setLedgerSubLedgerId(ledgerId);
      }
      if(type){
        setLedgerSubLedgertype(type);
      }
      setLedgeNameList(res.ledgers);
    });
  };
  
  const option2 =
    ledgerSubLedgerList &&
    ledgerSubLedgerList?.map((item, index) => ({
      id: item?._id,
      name: item?.ledger_name,
    }));

  const [loading, setLoading] = useState(false);
  // Get getLedgerSubLedgerList By Id
  const getLedgerSubLedgerListById = async (name, type, id) => {
    setLoading(true);
    setType(name);
    setLedgerSubledger(name);
    setLedgerSubLedgertype(type);
    setLedgerSubLedgerId(id);
    const token = await getAccessTokenSilently();
    if (id) {
      await FinanceSettingService.getLedgerSubLedgerById(type, id, token).then(
        (res) => {
          setLedgerSubLedgerData(res.result);
          setLoading(false);
        }
      );
    }
  };

  // update Ledger Subledger
  const updateLedgerSubLedgerById = async () => {
    const oldName = ledgerSubLedgerData?.ledger_name || ledgerSubLedgerData?.sub_ledger_name || "";
    const newName = formik.values?.ledger_name || "";
    if (oldName && newName && oldName.trim() !== newName.trim()) {
      setShowNameChangeConfirm(true);
      return;
    }
    await doUpdateLedgerSubLedger();
  };

  const doUpdateLedgerSubLedger = async () => {
    if(activeQuickBooksProgram !== "disable" && !formik.values?.quickBooks_name) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if((activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") && !formik.values?.quickBooks_id) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if (formik.values?.showOnCheckout) {
      if (!formik.values?.checkoutTitle?.trim()) {
        return toastr.info('Validation', "Please fill the checkout title");
      }
      if (!formik.values?.checkoutLabel?.trim()) {
        return toastr.info('Validation', "Please fill the checkout label");
      }
      if (!formik.values?.checkoutAllowOther && !(formik.values?.checkoutAmounts?.length > 0)) {
        return toastr.info('Validation', "Please add at least one amount or enable Allow other");
      }
    }
    if (formik.values?.ledger_name == "") {
      toastr.error("error", "Please enter a valid ledger name");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.updateLedgerSubLedgerById(
        ledgerSubLedgertype === "ledger"
          ? {
            type: ledgerSubLedgertype,
            id: ledgerSubLedgerId,

            data: {
              ledger_name: formik?.values?.ledger_name ?? "",
              account_receivable: formik?.values?.account_receivable,
              quickBooks_name: activeQuickBooksProgram !== "disable" ? formik?.values?.quickBooks_name : undefined,
              quickBooks_id: (activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") ? formik?.values?.quickBooks_id : undefined,
              quickBooksClass_id: activeQuickBooksProgram === "online"  ? formik?.values?.quickBooksClass_id : undefined,
              quickBooksClass_name: formik?.values?.quickBooksClass_name,
              donation: formik?.values?.donation
                ? formik?.values?.donation
                : formik?.values?.donation === ""
                  ? "false"
                  : "false",

              notes: formik?.values?.require_notes
                ? formik?.values?.require_notes
                : formik?.values?.require_notes === ""
                  ? "false"
                  : "false",

              defaultCOA: formik?.values?.defaultCOA
                ? formik?.values?.defaultCOA
                : formik?.values?.defaultCOA === ""
                  ? "false"
                  : "false",

              active: formik?.values?.archived
                ? formik?.values?.archived
                : formik?.values?.archived === ""
                  ? "false"
                  : "false",

              default_amount: formik?.values?.default_amount
                ? formik?.values?.default_amount
                : formik?.values?.default_amount === ""
                  ? 0
                  : 0,

              amount_detuctible: formik?.values?.amount_deductible
                ? formik?.values?.amount_deductible
                : formik?.values?.amount_deductible === ""
                  ? 0
                  : 0,
              deductibleType: formik?.values?.deductibleType || "%",
              showOnCheckout: formik?.values?.showOnCheckout ?? false,
              checkoutTitle: formik?.values?.checkoutTitle ?? "",
              checkoutLabel: formik?.values?.checkoutLabel ?? "",
              checkoutAmounts: formik?.values?.checkoutAmounts ?? [],
              checkoutAllowOther: formik?.values?.checkoutAllowOther ?? false,
              // gateway_fee: formik?.values?.gateway_fee_override
              //   ? formik?.values?.gateway_fee_override
              //   : formik?.values?.gateway_fee_override === ""
              //     ? 0
              //     : 0,
              // feeType: formik?.values?.feeType || "%",
            },
          }
          : {
            type: ledgerSubLedgertype,
            id: ledgerSubLedgerId,

            data: {
              sub_ledger_name: formik?.values?.ledger_name ?? "",
              account_receivable: formik?.values?.account_receivable,
              quickBooks_name: activeQuickBooksProgram !== "disable" ? formik?.values?.quickBooks_name : undefined,
              quickBooks_id: (activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") ? formik?.values?.quickBooks_id : undefined,
              quickBooksClass_id: activeQuickBooksProgram === "online"  ? formik?.values?.quickBooksClass_id : undefined,
              quickBooksClass_name: formik?.values?.quickBooksClass_name,
              donation: formik?.values?.donation
                ? formik?.values?.donation
                : formik?.values?.donation === ""
                  ? "false"
                  : "false",

              notes: formik?.values?.require_notes
                ? formik?.values?.require_notes
                : formik?.values?.require_notes === ""
                  ? "false"
                  : "false",


              defaultCOA: formik?.values?.defaultCOA
                ? formik?.values?.defaultCOA
                : formik?.values?.defaultCOA === ""
                  ? "false"
                  : "false",

              active: formik?.values?.archived
                ? formik?.values?.archived
                : formik?.values?.archived === ""
                  ? "false"
                  : "false",

              default_amount: formik?.values?.default_amount
                ? formik?.values?.default_amount
                : formik?.values?.default_amount === ""
                  ? 0
                  : 0,
              amount_detuctible: formik?.values?.amount_deductible
                ? formik?.values?.amount_deductible
                : formik?.values?.amount_deductible === ""
                  ? 0
                  : 0,
              deductibleType: formik?.values?.deductibleType || "%",
              showOnCheckout: formik?.values?.showOnCheckout ?? false,
              checkoutTitle: formik?.values?.checkoutTitle ?? "",
              checkoutLabel: formik?.values?.checkoutLabel ?? "",
              checkoutAmounts: formik?.values?.checkoutAmounts ?? [],
              checkoutAllowOther: formik?.values?.checkoutAllowOther ?? false,
              // gateway_fee: formik?.values?.gateway_fee_override
              //   ? formik?.values?.gateway_fee_override
              //   : formik?.values?.gateway_fee_override === ""
              //     ? 0
              //     : 0,
              // feeType: formik?.values?.feeType || "%",
              ledgerId:
                formik?.values?.ledgerId?.id ?? formik?.values?.ledgerId,
            },
          },
        token
      )
        .then((r) => {
          toastr.success("Success", "Ledgers/Subledgers updated successfully");
          // history.push("/ledger-accounts/view");
          push({
            pathname: addPath.replace("edit", "view"),
          });
          setLedgerSubledger(formik.values?.ledger_name ?? "");
          setLedgerSubLedgerData((prev) => ({ ...prev, ledger_name: formik.values?.ledger_name, sub_ledger_name: formik.values?.ledger_name }));
          fetchMyAPI(type,ledgerSubLedgerId,ledgerSubLedgertype);
        })
        .catch((error) => {
          toastr.error(
            "Update Error",
            error?.data?.message ?? "Some fields are missing"
          );
        });
    }
  };
  // Create A New ledger Subledger
  const createNewLedgerSubledger = async () => {
    if(activeQuickBooksProgram !== "disable" && !formik.values?.quickBooks_name) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if((activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") && !formik.values?.quickBooks_id) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if (formik.values?.showOnCheckout) {
      if (!formik.values?.checkoutTitle?.trim()) {
        return toastr.info('Validation', "Please fill the checkout title");
      }
      if (!formik.values?.checkoutLabel?.trim()) {
        return toastr.info('Validation', "Please fill the checkout label");
      }
      if (!formik.values?.checkoutAllowOther && !(formik.values?.checkoutAmounts?.length > 0)) {
        return toastr.info('Validation', "Please add at least one amount or enable Allow other");
      }
    }
    if (formik.values?.ledger_name == "") {
      toastr.error("error", "Please enter a valid ledger name");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.createNewLedgerSubledger(
        formik.values?.ledger_checkbox === true
          ? {
            type: "ledger",
            data: {
              ledger_name: formik?.values?.ledger_name ?? "",
              account_receivable: formik?.values?.account_receivable,
              quickBooks_id: (activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") ? formik?.values?.quickBooks_id : undefined,
              quickBooks_name: activeQuickBooksProgram !== "disable" ? formik?.values?.quickBooks_name : undefined,
              quickBooksClass_id: activeQuickBooksProgram === "online"  ? formik?.values?.quickBooksClass_id : undefined,
              quickBooksClass_name: formik?.values?.quickBooksClass_name,
              donation: formik?.values?.donation
                ? formik?.values?.donation
                : formik?.values?.donation === ""
                  ? "false"
                  : "false",

              notes: formik?.values?.require_notes
                ? formik?.values?.require_notes
                : formik?.values?.require_notes === ""
                  ? "false"
                  : "false",

              defaultCOA: formik?.values?.defaultCOA
                ? formik?.values?.defaultCOA
                : formik?.values?.defaultCOA === ""
                  ? "false"
                  : "false",

              active: formik?.values?.archived
                ? formik?.values?.archived
                : formik?.values?.archived === ""
                  ? "false"
                  : "false",

              default_amount: formik?.values?.default_amount
                ? formik?.values?.default_amount
                : formik?.values?.default_amount === ""
                  ? 0
                  : 0,

              amount_detuctible: formik?.values?.amount_deductible
                ? formik?.values?.amount_deductible
                : formik?.values?.amount_deductible === ""
                  ? 0
                  : 0,
              deductibleType: formik?.values?.deductibleType || "%",
              showOnCheckout: formik?.values?.showOnCheckout ?? false,
              checkoutTitle: formik?.values?.checkoutTitle ?? "",
              checkoutLabel: formik?.values?.checkoutLabel ?? "",
              checkoutAmounts: formik?.values?.checkoutAmounts ?? [],
              checkoutAllowOther: formik?.values?.checkoutAllowOther ?? false,
              // gateway_fee: formik?.values?.gateway_fee_override
              //   ? formik?.values?.gateway_fee_override
              //   : formik?.values?.gateway_fee_override === ""
              //     ? 0
              //     : 0,
              // feeType: formik?.values?.feeType || "%",
            },
          }
          : {
            type: "subLedger",

            data: {
              sub_ledger_name: formik?.values?.ledger_name ?? "",
              account_receivable: formik?.values?.account_receivable,
              quickBooks_id: (activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") ? formik?.values?.quickBooks_id : undefined,
              quickBooks_name: activeQuickBooksProgram !== "disable" ? formik?.values?.quickBooks_name : undefined,
              quickBooksClass_id: activeQuickBooksProgram === "online"  ? formik?.values?.quickBooksClass_id : undefined,
              quickBooksClass_name: formik?.values?.quickBooksClass_name,
              donation: formik?.values?.donation
                ? formik?.values?.donation
                : formik?.values?.donation === ""
                  ? "false"
                  : "false",

              notes: formik?.values?.require_notes
                ? formik?.values?.require_notes
                : formik?.values?.require_notes === ""
                  ? "false"
                  : "false",

              defaultCOA: formik?.values?.defaultCOA
                ? formik?.values?.defaultCOA
                : formik?.values?.defaultCOA === ""
                  ? "false"
                  : "false",

              active: formik?.values?.archived
                ? formik?.values?.archived
                : formik?.values?.archived === ""
                  ? "false"
                  : "false",

              default_amount: formik?.values?.default_amount
                ? formik?.values?.default_amount
                : formik?.values?.default_amount === ""
                  ? 0
                  : 0,
              amount_detuctible: formik?.values?.amount_deductible
                ? formik?.values?.amount_deductible
                : formik?.values?.amount_deductible === ""
                  ? 0
                  : 0,
              deductibleType: formik?.values?.deductibleType || "%",
              showOnCheckout: formik?.values?.showOnCheckout ?? false,
              checkoutTitle: formik?.values?.checkoutTitle ?? "",
              checkoutLabel: formik?.values?.checkoutLabel ?? "",
              checkoutAmounts: formik?.values?.checkoutAmounts ?? [],
              checkoutAllowOther: formik?.values?.checkoutAllowOther ?? false,
              // gateway_fee: formik?.values?.gateway_fee_override
              //   ? formik?.values?.gateway_fee_override
              //   : formik?.values?.gateway_fee_override === ""
              //     ? 0
              //     : 0,
              // feeType: formik?.values?.feeType || "%",
              ledgerId: formik?.values?.ledgerId?.id ?? "",
              account_receivable: formik?.values?.account_receivable,
              quickBooks_id: (activeQuickBooksProgram === "online" || activeQuickBooksProgram === "sage") ? formik?.values?.quickBooks_id : undefined,
              quickBooks_name: activeQuickBooksProgram !== "disable" ? formik?.values?.quickBooks_name : undefined,
            },
          },
        token
      )
        .then(() => {
          toastr.success("Success", "New Ledger/Subledger has been created");
          history.push("/financial-setting/ledger-accounts/view");
          fetchMyAPI();
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
    }
  };
  // Disable A LedgerSubledger
  const disableLedgerSubledgerById = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.deleteLedgerSubledgerById(
      token,
      ledgerSubLedgertype || ledgerSubLedgerList[0]?.ledger_name,
      ledgerSubLedgerId || ledgerSubLedgerList[0]._id
    ).then((res) => {
      if (res) {
        if (
          ledgerSubLedgertype === "ledger" &&
          ledgerSubLedgerId == ledgerSubLedgerList[0]._id
        ) {
          var filteredList = ledgerSubLedgerList?.filter(function (el) {
            return el?.ledger_name != res?.result?.ledger_name;
          });
        }
        setLedgerSubLedgerList([filteredList]);
        fetchMyAPI();
      }
    })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);
  useEffect(() => {
    fetchMyAPI();
  }, []);

  // const getTypeID = (name) => {
  //   setTypeID(name);
  // };
  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue.length > 1) {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.searchLedgerByName(searchValue, token).then(
          (res) => {
            setLedgerSubLedgerList(res?.ledgers);
          }
        );
      }
    }, 1000),
    [searchValue]
  );
  useEffect(() => {
    if (searchValue === "") {
      fetchMyAPI();
    } else {
      setLedgerSubLedgerData(null);
      setSelected("");
      setSelectedSubLedger({});
      setSearchValue(searchValue);
      debounceSearch();
      if(pathname.includes("view")) return;
      push({
        pathname: pathname.replace("edit", "view"),
      });
    }
  }, [searchValue]);
  // const onSearchChange = (e) => {
  //   const { value } = e.target;

  //   setSearchValue(value);
  // };

  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);
  return IsSettingsActive == false ? (
    <NotAuthorized title={"LedgerAccounts"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/ledger-accounts/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">
      <div className=" mb-5 search-input-types ">
        <SearchDownShift
          items={option2}
          name={searchValue}
          setName={setSearchValue}
          placeHolder="Search ledger by name or number"
          autoFocus
        />
      </div>
      <div className="setting-main">
        <div className="left-menu-div col-md-3">
            <Tree
              btnText={"Add Ledger"}
              disableAddNew={disableAddNew}
              setAddNew={setAddNew}
              setDisable={setDisable}
              chargeTypeTree={false}
              setDaisableAddNew={setDaisableAddNew}
              getTypeID={getLedgerSubLedgerListById}
              treeData={ledgerSubLedgerList ? ledgerSubLedgerList : []}
              addPath={addPath}
              formik={formik}
              selected={selected}
              setSelected={setSelected}
              selectedSubLedger={selectedSubLedger}
              setSelectedSubLedger={setSelectedSubLedger}
            />
        </div>
        <div className="settings-details">
          {
            loading ?
              <div className="">
                <Loader />
              </div> :
              (!ledgerSubLedgerData?._id && !addNew) ? (
                <div className="mt-40 ledgers-settings-empty">
                  <DefaultEmptyMsg msg="Please select a ledger or sub-ledger" size="30px"/>
                </div>
              ) : (
                <ComponentHeading
                  type={type}
                  heading={heading}
                  addNew={addNew}
                  disable={disable}
                  setDaisableAddNew={setDaisableAddNew}
                  setDisable={setDisable}
                  edit={edit}
                  setEdit={setEdit}
                  setAddPath={setAddPath}
                  ledgerSubLedgerData={ledgerSubLedgerData}
                  formik={formik}
                  createFunc={createNewLedgerSubledger}
                  setAddNew={setAddNew}
                  updateFunc={updateLedgerSubLedgerById}
                  showNameChangeConfirm={showNameChangeConfirm}
                  setShowNameChangeConfirm={setShowNameChangeConfirm}
                  onConfirmNameChange={doUpdateLedgerSubLedger}
                  ledgerSubLedgerData={ledgerSubLedgerData}
                  ledgerNameList={ledgerNameList}
                  addPath={addPath}
                  deleteFunc={disableLedgerSubledgerById}
                />
              )
          }
        </div>
      </div>
      </div>
    </div>
  );
};

export default LedgerAccounts;
